import { useEffect, useState } from "react";

import { api, formatApiError } from "@/lib/api";

const actionLabels = {
  created: "Created",
  deactivated: "Deactivated",
  edited: "Edited",
  reassigned: "Reassigned",
  reactivated: "Reactivated",
  removed_from_batch: "Removed from batch",
};

function formatTimestamp(timestamp) {
  return new Intl.DateTimeFormat("en", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(timestamp));
}

export default function CenterManagerLearnerAudit({ refreshKey }) {
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    api
      .get("/lms/center-manager/learner-audit")
      .then((response) => {
        if (isMounted) {
          setItems(response.data.items);
          setError("");
        }
      })
      .catch((requestError) => {
        if (isMounted) {
          setError(formatApiError(requestError));
        }
      });

    return () => {
      isMounted = false;
    };
  }, [refreshKey]);

  return (
    <section className="attendance-report" data-testid="center-manager-learner-audit-section">
      <div className="section-heading">
        <div>
          <p className="eyebrow">Learner audit history</p>
          <h2>Recent learner changes</h2>
        </div>
      </div>
      {items === null && (
        <p data-testid="center-manager-learner-audit-loading">Loading learner audit history.</p>
      )}
      {error && (
        <p className="form-error" data-testid="center-manager-learner-audit-error">
          {error}
        </p>
      )}
      {items?.length === 0 && (
        <div className="attendance-empty-state" data-testid="center-manager-learner-audit-empty">
          No learner changes have been recorded for this training center yet.
        </div>
      )}
      {items?.length > 0 && (
        <div className="data-table-wrap">
          <table data-testid="center-manager-learner-audit-table">
            <thead>
              <tr>
                <th>When</th>
                <th>Learner</th>
                <th>Change</th>
                <th>Details</th>
                <th>Manager</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.id} data-testid={`center-manager-audit-row-${item.id}`}>
                  <td>{formatTimestamp(item.timestamp)}</td>
                  <td>
                    <strong>{item.learner_name}</strong>
                    {item.learner_email && <span>{item.learner_email}</span>}
                  </td>
                  <td>{actionLabels[item.action] || item.action}</td>
                  <td>{item.details}</td>
                  <td>{item.actor_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}